<template>
  <div style="background: #f9f9f9">
    <!--    <img src="./model.svg" alt="" style="width: 100%;">-->
    <div class="softMarketTop">
      <div class="softMarketTopSearch">
        <div class="logoTitle">
          <div class="logoTitle1">
            宁夏工业企业数字化转型公共服务平台商
          </div>
        </div>
        <div class="searchContainer">
          <div class="flex searchContainerone">
            <el-input
              placeholder="请输入内容"
              v-model="searchValue"
              class="input-with-select"
              @keyup.native.enter="getList"
              prefix-icon="el-icon-search"
            >
              <el-button slot="append" @click="getList">
                搜索
              </el-button>
            </el-input>
            <el-button
              round
              class="searchContainerButton"
              @click="toServiceAuthentication"
              icon="el-icon-s-shop"
            >
              商家入驻
            </el-button>
          </div>
          <ul>
            <li
              class="textLi"
              @click="searchByKeyword(items)"
              v-for="(items, index) in keywords"
            >
              {{ items }}
            </li>
          </ul>
        </div>
        <div class="shoppingCar" v-if="isShow">
          <el-badge :value="goodsNum" class="item" style="margin-top:7px">
            <el-button
              size="small"
              icon="el-icon-shopping-cart-full"
              @click="$router.push('/shopCar')"
              >我的购物车</el-button
            >
          </el-badge>
        </div>
      </div>
    </div>
    <div class="shopTitlenap">
      <p>当前位置：</p>
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/mall' }"
          >宁夏工业企业数字化转型公共服务平台商</el-breadcrumb-item
        >
        <el-breadcrumb-item>全部店铺</el-breadcrumb-item>
      </el-breadcrumb>
      <!--  <span>宁夏工业企业数字化转型公共服务平台商</span>
            <i class="el-icon-arrow-right"></i>
            <span class="blue"> 全部店铺</span> -->
      <!-- <i class="el-icon-arrow-right"></i>
            <span class="blue"> 水泵打印</span> -->
    </div>
    <div class="print_news flex">
      <div class="flex print_news1">
        <p class="print_title">排序：</p>
        <p
          style="cursor: pointer"
          :class="orderByInfo === 'createTime' ? 'print_sort' : ''"
          @click="getPrintNews('createTime')"
          :key="-1"
        >
          最新
          <i class="el-icon-bottom" v-if="getPrintNews1 == 0"></i>
          <i class="el-icon-top" v-if="getPrintNews1 == 1"></i>
        </p>
        <p
          style="cursor: pointer"
          :class="orderByInfo === items.value ? 'print_sort' : ''"
          v-for="(items, index) in printNewss"
          :key="index"
          @click="getPrintNews(items.value)"
        >
          {{ items.title }}
          <!-- <i class="el-icon-arrow-down"></i> -->
          <i class="el-icon-bottom" v-if="index == 0 && getPrintNews2 == 0"></i>
          <i class="el-icon-top" v-if="index == 0 && getPrintNews2 == 1"></i>
          <i class="el-icon-bottom" v-if="index == 1 && getPrintNews3 == 0"></i>
          <i class="el-icon-top" v-if="index == 1 && getPrintNews3 == 1"></i>
        </p>
      </div>
    </div>
    <!-- 列表 -->
    <div class="container">
      <section style="padding-bottom: 30px">
        <div class="dmessagesBottom" v-loading="loading">
          <div
            class="flex shopMall"
            v-for="(items, index) in modelList"
            :key="index"
          >
            <div class="flex shopMallBox">
              <img :src="items.storeLogo" alt="" />
              <div class="shopMallMess">
                <h5>
                  {{ items.enterPriseName }}
                  <!--<span class="blue">商家</span>-->
                </h5>
                <p class="shopArr">
                  <span> 地址： </span>
                  {{ items.province1 }}{{ items.city1 }}{{ items.district1
                  }}{{ items.address1 }}
                </p>
                <div class="flex shopGoods">
                  <p>
                    共 <span class="blue"> {{ items.goodsNum }} </span> 件宝贝
                  </p>
                  <p>
                    最近成交 <span class="blue"> {{ items.orderNum }} </span> 笔
                  </p>
                </div>
                <p class="shopArrgood">
                  <span> 好评率： </span>
                  <el-rate
                    v-model="items.goodsPercent"
                    disabled
                    :colors="colors"
                  >
                  </el-rate>
                </p>
                <a
                  href="javascript:void(0);"
                  class="blue"
                  @click="goToDetail(items.enterpriseUuid)"
                  style="font-size: 14px"
                >
                  进入店铺
                </a>
              </div>
            </div>
            <div class="shopMallBoxMess">
              <div
                v-if="items.infoList.length == 0"
                style="text-align:center;margin-bottom:20px;width: 100%;"
              >
                <img
                  src="../../assets/noMesge.jpg"
                  alt=""
                  style="width:200px"
                />
              </div>
              <div
                class="dmessagesBottombox"
                v-if="items.infoList.length > 0 && indexs < 3"
                @click="handGoodsDetails(mess.uuid)"
                v-for="(mess, indexs) in items.infoList"
                :key="indexs"
              >
                <img :src="mess.imgUrl" alt="" />
                <div class="sdmessagesbotMes">
                  <div class="flex brandBox">
                    <p class="brand" v-if="mess.brand">{{ mess.brand }}</p>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="mess.name"
                      placement="bottom"
                    >
                      <h4>{{ mess.name }}</h4>
                    </el-tooltip>
                  </div>
                  <span>¥{{ mess.minPrice }}</span>
                </div>
              </div>
            </div>
          </div>
          <div style="text-align:center" v-if="modelList.length == 0">
            <img
              src="../../assets/nosearchMesg.jpg"
              alt=""
              style="width:200px"
            />
          </div>
        </div>
        <div style="text-align: center; width: 100%; margin: 30px 0">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            @prev-click="handleCurrentChange"
            @next-click="handleCurrentChange"
            layout="total,prev, pager, next,jumper"
            :page-size="pageSize"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </section>
    </div>
    <!-- 优质商家 -->
    <!-- <div class="goods" ref="merchants">
            <div class="goodsbox">
                <div class="flex swiperTopTitle">
                    <h2>推荐商家</h2>
                </div>
                <div class="goodsImg flex">
                    <img
                        :src="items.logo"
                        alt=""
                        @click="goToDetail(items.enterpriseUuid)"
                        v-for="(items, index) in merchants"
                        :key="index"
                    />
                </div>
            </div>
        </div> -->
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getNewcurrent,
  designerByUserId,
  getShopCarNumber,
  findRecommendList,
} from "../../utils/interface"
import { mapState, mapMutations } from "vuex"

export default {
  //   商城列表
  name: "shopMallList",
  metaInfo: {
    title:
      "宁夏工业企业数字化转型公共服务平台商-提供水泵行业优质零部件及产品资源-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "宁夏工业企业数字化转型公共服务平台|水泵行业供需对接平台|盐湖区水泵企业|盐湖区水泵产业链 | 水泵配件 | 水泵零部件采购",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台|水泵行业供需对接平台|盐湖区水泵企业|盐湖区水泵产业链 | 水泵配件 | 水泵零部件采购",
      },
    ],
  },
  data() {
    return {
      loading: true,
      getPrintNews1: 0,
      getPrintNews2: 0,
      getPrintNews3: 0,
      setIn: null,
      bannerList: [],
      searchValue: "",
      valueStare: 4,
      colors: ["#ff0000", "#ff0000", "#ff0000"], // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
      modelList: [],
      merchants: [],
      printNewss: [
        {
          value: "orderNum",
          title: "销量",
        },
        {
          value: "volume",
          title: "人气",
        },
        /*{
                    value: 'feedback',
                    title: "好评",
                },*/
      ],
      userMessages: {},
      // 商家入驻信息
      identity: "",
      // 列表信息
      current: 1,
      pageSize: 5,
      total: 0,
      orderBy: "goodsNum_descend",
      orderByInfo: "goodsNum",
      keywords: [],
      goodsNum: 0,
      isShow: false,
    }
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
      isUsermessage: "isUsermessage",
    }),
    itemWidth() {
      return 216
      //rem布局 计算列宽度
      //可以根据自己的rem设置修改这里的 334 值
    },
    gutterWidth() {
      return 30

      //rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)

      //可以根据自己的rem设置修改这里的 36 值
    },
  },
  created() {
    this.getShopCarNumber()
    getDictionaryItem({ groupCode: "shop_store_keyword" }).then((res) => {
      if (res != null && res.length > 0) {
        res.forEach((item, index) => {
          this.keywords.push(item.name)
        })
      }
    })
    // 获取列表信息
    this.getList()
    // 获取优质商家
    this.findRecommendList()
    // 获取用户信息
    getNewcurrent()
      .then((res) => {
        this.userMessages = res
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    getShopCarNumber() {
      if (this.isLogin) {
        this.isShow = true
        getShopCarNumber().then((res) => {
          if (res.success) {
            this.goodsNum = res.data
          }
        })
      } else {
        this.isShow = false
      }
    },
    handGoodsDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "shopGoodDetails",
        params: { uuid: uuid },
      })
      window.open(routeData.href, "_blank")
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val
      window.scrollTo(0, 0)
      this.getList()
    },
    searchByKeyword(keyword) {
      this.searchValue = keyword
      this.getList()
    },
    getList() {
      this.loading = true
      let params = {
        name: this.searchValue,
        current: this.current,
        pageSize: this.pageSize,
        orderBy: this.orderBy,
      }
      findRecommendList(params).then((res) => {
        this.total = res.total
        this.modelList = res.list
        this.modelList.forEach((items) => {
          if (!items.storeLogo) {
            items.storeLogo = require("../../assets/storeLogo.jpeg")
          }
        })
        this.loading = false
      })
    },
    // 进店看看
    goToDetail(enterpriseUuid) {
      // uuid 店铺信息
      // enterPriseUuid 企业id
      // 跳转到详情页
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId: enterpriseUuid },
      })
      window.open(routeData.href, "_blank")
    },
    findRecommendList() {
      let params = {
        current: 1,
        pageSize: 18,
        isRecommend: 1,
      }
      findRecommendList(params).then((res) => {
        this.merchants = res.list
      })
    },
    ...mapMutations(["isLoginVuex"]),
    // 商家入驻
    toServiceAuthentication() {
      if (this.$store.state.isLogin) {
        getNewcurrent().then((data) => {
          this.identity = data.identity
          if (this.identity === "ENTERPRISE") {
            this.$router.push({
              name: "shopServiceAuthentication",
            })
          } else if (
            this.identity === "PERSONAL" ||
            this.identity === "ANONYMOUS"
          ) {
            this.$confirm("请先进行企业资质认证!", "提示", {
              confirmButtonText: "去认证",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              window.sessionStorage.setItem("userServeId", "11")
              let routeData = this.$router.resolve({
                name: "userCenter",
              })
              window.open(routeData.href, "_target")
            })
          }
        })
      } else {
        this.$message({
          type: "error",
          message: "您需要先登录哦！",
        })
        this.$router.push("/login")
        return false
      }
    },
    getPrintNews(value) {
      if (value == "createTime" && this.getPrintNews1 == 0) {
        this.getPrintNews1 = 1
        this.orderBy = value + "_ascend"
      } else if (value == "createTime" && this.getPrintNews1 == 1) {
        this.getPrintNews1 = 0
        this.orderBy = value + "_descend"
      } else if (value == "orderNum" && this.getPrintNews2 == 0) {
        this.getPrintNews2 = 1
        this.orderBy = value + "_ascend"
      } else if (value == "orderNum" && this.getPrintNews2 == 1) {
        this.getPrintNews2 = 0
        this.orderBy = value + "_descend"
      } else if (value == "volume" && this.getPrintNews3 == 0) {
        this.getPrintNews3 = 1
        this.orderBy = value + "_ascend"
      } else if (value == "volume" && this.getPrintNews3 == 1) {
        this.getPrintNews3 = 0
        this.orderBy = value + "_descend"
      }
      this.orderByInfo = value
      this.getList()
    },
  },
}
</script>

<style scoped lang="less">
.blue {
  color: #009999;
}

.container {
  width: 1200px;
  margin: 0 auto;

  /deep/ .vue-waterfall {
    overflow-y: unset;
    overflow-x: unset;
  }
}

.shopTitlenap {
  width: 1200px;
  margin: 20px auto 26px;
  font-size: 14px;
  align-items: center;
  display: flex;

  p {
    color: #808080;
  }

  i {
    margin: 0 2px;
  }

  .blue {
    color: #009999;
  }
}

.print_screen {
  background: #f9f9f9;

  .print_screen_box {
    background: #fff;
    width: 1200px;
    margin: 0 auto;
    // flex-wrap: wrap;
    padding: 20px 15px 10px 20px;
    box-sizing: border-box;

    .print_title {
      flex-shrink: 0;
      color: #808080;
      padding-right: 41px;
      padding-left: 0px;
    }

    .print_screen_boxP {
      display: flex;
      flex-wrap: wrap;

      p {
        cursor: pointer;
      }

      .screen_text {
        color: #009999;
        background: #009999;
        border-radius: 5px;
        margin-bottom: 10px;
        color: #fff;
        padding: 3px 15px;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .screen_text {
      color: #009999;
      cursor: pointer;
      background: #009999;
      border-radius: 5px;
      margin-bottom: 10px;
      color: #fff;
      padding: 3px 15px;
      font-size: 14px;
    }

    p {
      margin-bottom: 10px;
      margin-right: 0px;
      padding: 3px 14px;
      font-size: 14px;
    }

    .materDetailsT {
      // background: #009999;
      color: #009999;
      border-radius: 5px;
      padding: 3px 15px;
      margin-bottom: 10px;
    }
  }

  .print_screen_box:nth-last-child(1) {
    border-top: 1px solid #efefef;
  }
}

.print_news {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  height: 50px;
  justify-content: space-between;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  // line-height: 50px;

  p {
    font-size: 14px;
    padding: 3px 15px;
    margin-right: 10px;
    border-radius: 3px;
    padding: 3px 9px;
  }

  .print_news1 {
    padding-left: 15px;
    flex-shrink: 0;
    color: #333;

    .print_title {
      flex-shrink: 0;
      color: #808080;
      padding-right: 41px;
      padding-left: 0px;
    }

    .priceIconbox {
      align-items: center;

      .priceIcon {
        display: flex;
        flex-direction: column;
        margin-left: 2px;

        i {
          height: 10px;
          font-size: 12px;
        }
      }
    }
  }
}

.print_shai {
  font-size: 14px;

  p {
    background: #fff;
    padding: 3px 15px;
  }

  .print_newsP {
    margin-right: 30px;
    cursor: pointer;
    background: #fff;
    border-radius: 3px;
    padding: 3px 15px;
  }

  .print_newsPs {
    color: #fff;
    background: #009999;
    border-radius: 5px;
    padding: 3px 15px;
  }
}

.print_sort {
  // color: #009999;
  color: #fff;
  background: #009999;
}

.print_input {
  width: 1200px;
  margin: 0 auto;
  text-align: right;

  position: relative;
  margin-bottom: 15px;
  margin-top: 15px;

  p {
    color: #009999;
  }
}

.softMarketTop {
  width: 100%;
  // height: 110px;
  background: #fff;
  box-sizing: border-box;

  .softMarketTopSearch {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    padding-top: 18px;
    // padding-bottom: 18px;
    box-sizing: border-box;
    padding-bottom: 14px;
    .logoTitle {
      font-size: 24px;
      // line-height: 74px;
      color: #009999;
      font-weight: bold;
      width: 246px;
      .logoTitle1 {
        height: 40px;
        color: #000;
      }
    }

    .searchContainer {
      // width: 690px;
      margin: 0 auto;
      padding: 0 15px;
      // padding-left: 232px;

      .searchContainerone {
        .input-with-select {
          flex-shrink: 0;
        }

        .searchContainerButton {
          color: #009999;
          margin-left: 60px;
          border: 1px solid #009999;
          background: #fff;
          font-size: 14px;
        }
      }

      /deep/ .input-with-select .el-input__inner {
        border: 2px solid #009999;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        background: #fdfdfd;
        height: 40px;
        line-height: 40px;
      }

      /deep/ .el-input-group {
        height: 40px;
        width: 618px;
      }

      /deep/ .input-with-select .el-input-group__append {
        background: #009999;
        color: #fff;
        border: 1px solid #009999;
        border-left: none;
        border-radius: 0px 20px 20px 0px;
        width: 80px;
        box-sizing: border-box;
        text-align: center;
      }

      ul {
        display: flex;
        align-items: center;
        color: #6e6e6e;
        padding-left: 3px;

        li {
          font-size: 12px;
          margin-top: 10px;
          padding: 0 15px;

          &.textLi {
            border-right: 1px solid #6e6e6e;
            cursor: pointer;

            &:hover {
              color: #009999;
            }
          }
          &.textLi:last-child {
            border: none !important;
          }
        }
      }
    }
  }
}

.dmessagesBottom {
  display: flex;
  justify-content: center;
  background: #fff;
  // padding: 34px 20px;
  flex-wrap: wrap;

  .dmessagesBottombox {
    // width: 216px;
    margin-bottom: 25px;
    margin-right: 22px;

    &:nth-last-of-type(1) {
      margin-right: 0;
    }

    img {
      // width: 100%;
      // height: 138px;
      width: 180px;
      height: 105px;
      background: #efefef;
      display: block;
      cursor: pointer;
    }

    .sdmessagesbotMes {
      cursor: pointer;
      // width: 100%;
      // height: 80px;
      width: 180px;
      height: 45px;
      color: #0f1826;
      text-align: center;
      background: #f5f5f5;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .brandBox {
        align-items: center;
        justify-content: center;
        width: 160px;
      }
      h4 {
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-size: 10px;
        font-weight: 400;
      }

      span {
        font-size: 12px;
        font-weight: bold;
        color: #ff0000;
      }
    }
  }

  .shopMall {
    // justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #efefef;
    padding: 34px 20px 0;

    .shopMallBox {
      flex-shrink: 0;
      width: 457px;

      img {
        width: 64px;
        height: 63px;
        border-radius: 50%;
        background: #efefef;
        margin-right: 20px;
      }
    }

    .shopMallMess {
      font-size: 14px;
      color: #333;

      h5 {
        font-size: 16px;
        margin-bottom: 12px;

        span {
          font-size: 14px;
          font-weight: normal;
          margin-left: 20px;
        }
      }

      .shopArr {
        margin-bottom: 20px;

        span {
          color: #808080;
        }
      }

      .shopGoods {
        margin-bottom: 10px;

        p:nth-of-type(1) {
          margin-right: 20px;
        }
      }

      .shopArrgood {
        display: flex;
        margin-bottom: 10px;

        span {
          color: #808080;
        }
      }
    }

    .shopMallBoxMess {
      display: flex;
    }
  }
}

.goods {
  .goodsbox {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 26px;

    .swiperTopTitle {
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
      text-align: center;

      h2 {
        font-size: 24px;
        font-weight: 500;
        color: #333333;
      }
    }
  }

  .goodsImg {
    flex-wrap: wrap;
    // justify-content: space-between;
    img:nth-of-type(1) {
      margin-left: 0px;
    }
    img {
      width: 189px;
      height: 90px;
      background: #efefef;
      margin-bottom: 20px;
      cursor: pointer;
      border-radius: 10px;
      margin-left: 10px;
    }

    .goodsImgbox {
      width: 189px;
      height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/threeShop/shopMallList.vue